import { type CookieAddress, type DeliveryAddress } from './entities'
import { getConfig } from '@/tools/config'
import { fetcher } from '@/tools/fetcher/client'
import type { GoogleAddress } from '@/user/address-book/entities'

export const mapCookieAddressToDeliveryAddress = (
  cookieAddress?: CookieAddress
): DeliveryAddress | null =>
  cookieAddress
    ? {
        latitude: cookieAddress.geo.lat,
        longitude: cookieAddress.geo.lng,
        cityCode: cookieAddress.city.code,
        countryCode: cookieAddress.city.countryCode,
        cityName: cookieAddress.city.name,
        text: cookieAddress.text,
        details: cookieAddress.details,
        placeId: cookieAddress.placeId,
        isVerified: cookieAddress.isVerified || false,
      }
    : null

export const mapDeliveryAddressToCookieAddress = async (
  address: DeliveryAddress,
  isAuthUser: boolean = false
): Promise<CookieAddress> => {
  const { apiUrl } = getConfig()
  const googleAddressResponse = await fetcher.get<GoogleAddress>(
    `${apiUrl}/v3/addresslookup/${isAuthUser ? '' : 'pub/'}coordinates?latitude=${address.latitude}&longitude=${address.longitude}`
  )
  const { placeId } = googleAddressResponse.data

  return {
    geo: {
      lat: address.latitude,
      lng: address.longitude,
    },
    city: {
      code: address.cityCode,
      name: address.cityName,
      countryCode: address.countryCode,
    },
    placeId: placeId,
    text: address.text,
    details: address.details,
    isVerified: address.isVerified,
  }
}

export const mapCookieAddressDataToDeliveryAddress = (
  data: string | undefined
): DeliveryAddress | null => {
  if (!data) {
    return null
  }
  const decodedValue = decodeURI(data)
  const cookieData = JSON.parse(decodedValue)
  return cookieData ? mapCookieAddressToDeliveryAddress(cookieData) : null
}
